import { checkUserPermissions } from '@/services/auth';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';

//import Teams from './screens/index.vue';
const Teams = () => import('./screens/index.vue')

const teamRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.TEAM_INSERT,
    PERMISSIONS_KEYS.TEAM_EDIT,
    PERMISSIONS_KEYS.TEAM_VIEW,
    PERMISSIONS_KEYS.TEAM_DELETE,
  ])
) {
  teamRoutes.push({
    path: '/regras-da-prescricao/times',
    name: 'Cadastro / Consulta|Time Médico',
    component: Teams,
    meta: {
      icon: 'settings',
      requiresAuth: true,
    },
  });
}

export { teamRoutes };
